import * as React from 'react';
import { Table } from 'react-bootstrap';

function ListSkeleton() {
    return (
        <>
            <p className="logs__skeleton-header" />
            <div className="logs__skeleton-row" />
            <div className="logs__skeleton-row" />
            <div className="logs__skeleton-row" />

            <h2 className="logs__skeleton-header" />
            <div className="logs__skeleton-row" />
            <div className="logs__skeleton-row" />
            <div className="logs__skeleton-row" />
        </>
    );
}

export default ListSkeleton;